import { render, staticRenderFns } from "./form5.vue?vue&type=template&id=3a735f6f&scoped=true&"
import script from "./form5.vue?vue&type=script&lang=js&"
export * from "./form5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a735f6f",
  null
  
)

export default component.exports